<div style="background-color: #F0F3FA;" class="action-box">
  <div class="modal-header action-header">
    <div class="own-action-header-title">
      <h3 class="own-action-modal-title">{{'create_own_action' | translate}}</h3>
      <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" (click)="close()"
           style="margin: 0 0 3rem 0; cursor: pointer">
    </div>
    <div [ngStyle]="{'background-color': config.statement?.color.hex}" class="own-statement-item">
      <i style="margin-left: 1.6rem;color:white" class="bi bi-chat-fill statement-icon"></i>
      <h3 class="own-statement-question-title">{{config.statement?.question.title}}</h3>
    </div>
    <div class="own-action-form-container">
      <form [formGroup]="challengesService.createActionForm">
        <div class="own-task-form">
          <div
            style="display: flex; border-radius: 1.4rem; background-color: white">
            <img style="margin: 0 .2rem .4rem 2rem;" src="../../../assets/svg/action-active.svg">
            <input class="task-title-input" formControlName="actionTitle" id="actionTitleModal"
                   style="font-size: 1.8rem; color: #2551BF; margin-top: .8rem; width: -webkit-fill-available;"
                   placeholder="{{'easy_title' | translate}}">
          </div>
          <textarea style="font-size: 1.2rem; color: #2551BF;margin:0 0 0 2rem; border: none"
                    class="task-description-input" formControlName="actionDescription"
                    placeholder="{{'describe_solution' | translate}}" type="text"></textarea>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-body action-body">
    <div style="width: 50%; margin: 0 0 1rem 2rem" class="solutions-actions justify-content-start">
      <div *ngIf="data.teamLeaders.length === 1">
        <button *ngFor="let member of data.teamLeaders" pButton type="button"
                (click)="close({member: member})"
                class="assign-to-modal-button" label="{{'assign_to_me' | translate}}">
        </button>
      </div>
      <p-dropdown *ngIf="data.teamLeaders.length > 1" [options]="data.teamLeaders" [(ngModel)]="selectedTeamLeader" class="team-type-dropdown" optionLabel="name" placeholder="{{'assign_to' | translate}}" dropdownIcon="bi bi-chevron-down">
        <ng-template let-selectedLeader pTemplate="selectedItem">
          <div class="sort-item sort-item-value" *ngIf="selectedTeamLeader">
            <span>{{ selectedLeader.user.detail.displayName | getDisplayName: selectedLeader.user.detail.firstname: selectedLeader.user.detail.lastname: selectedLeader.user.email }}</span>
            <img class="action-assigned-user-icon"
                 src="{{(selectedLeader.user.avatar !== null && selectedLeader.user.avatar.path !== null) ? data.baseUrl + selectedLeader.user.avatar.path: '../../../assets/svg/user-icon.svg'}}">
          </div>
        </ng-template>
        <ng-template let-leader pTemplate="item">
          <div (click)="!data.showDemo ? close({member: leader}) : ''">
            <span>{{ leader.user.detail.displayName | getDisplayName: leader.user.detail.firstname: leader.user.detail.lastname: leader.user.email }}</span>
            <img class="action-assigned-user-icon"
                 src="{{(leader.user.avatar !== null && leader.user.avatar.path !== null) ? data.baseUrl + leader.user.avatar.path: '../../../assets/svg/user-icon.svg'}}">
          </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>
</div>
